<form [formGroup]="form" (ngSubmit)="accept()">
    <h1 mat-dialog-title>Clasificar informes</h1>
    <div mat-dialog-content>
        <mat-spinner diameter="30" *ngIf="loading"></mat-spinner>
        <mat-form-field *ngIf="!loading" class="full-width">
            <mat-select formControlName="category" placeholder="Categoría" required>
                <mat-option *ngFor="let category of categories" [value]="category">
                    {{ category.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.category.errors && f.category.errors.required">
                Seleccione una categoría
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Aceptar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
        Cancelar
      </button>
        </div>
    </div>
</form>